import { render, staticRenderFns } from "./OriginFilter.vue?vue&type=template&id=de8c4f04&scoped=true&"
import script from "./OriginFilter.vue?vue&type=script&lang=js&"
export * from "./OriginFilter.vue?vue&type=script&lang=js&"
import style0 from "./OriginFilter.vue?vue&type=style&index=0&id=de8c4f04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8c4f04",
  null
  
)

export default component.exports